import './_config'

import axios from 'axios'
import queryString from 'query-string'
import store from './store'
import { is_out } from './modules/actions/Login'
import T from './translate/T'


let language = ''

//polyfill ie param
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
        window.location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=")
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
    return result
}
//ie not found
// var urlParams = new URLSearchParams(window.location.search);
// language = urlParams.get('lang')
language = findGetParameter('lang')

// alert(language)

if(!language)
language = localStorage.getItem('language')


if(!language)
language = navigator.browserLanguage || navigator.language


language = T.setLanguage(language)
localStorage.setItem('language', language)


T.handleUpdate(language => {
    localStorage.setItem('language', language)

    if(store.getState().login.isLogged) {
        axios.post(`users/update_language`, {
            language
        })
    }
})

axios.defaults.baseURL = window.URL_API


function languageSet(request) {
    request.headers.Language = T.getLanguage()
    return request
}

T.handleUpdate(() => {
    axios.interceptors.request.use(languageSet)
})

function requestInterceptor(request) {
    request.headers.Auth = localStorage.getItem('authorization')
    if(store.getState().login.authorization !== '')
        request.headers.Auth = store.getState().login.authorization

    if (request.data && request.data.constructor === FormData) {
        request.headers['Content-Type'] = 'multipart/form-data'
    }

    if (request.data && request.data.constructor === Object) {
        request.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        request.data = queryString.stringify(request.data)
    }
    return request
}

function successInterceptor(response) {
    if(response.data.errors) {
        if(response.data.errors[0].parameter_name === 'Authorization') {
            store.dispatch(is_out())
        }
    }

    return response.data
}

function errorInterceptor(error) {
    console.log("Error:")
    console.error(error)
}

axios.interceptors
    .request.use(requestInterceptor)



axios.interceptors
    .response
    .use(successInterceptor, errorInterceptor)



// WEBPACK FOOTER //
// ./src/config.js